<template>
  <div class="contenedor-principal">
    <!-- IZQUIERDA: Selects -->
    <div class="panel-selects">
      <span
        style="font-weight: bolder;text-transform: uppercase; font-size:11px"
        >{{ item.text }}</span
      >

      <v-select
        :options="item.etapas"
        placeholder="Etapa"
        :clearable="false"
        v-model="etapaSeleccionado"
        style="margin-bottom:4px; font-size:11px"
      />

      <v-select
        :options="etapaSeleccionado ? etapaSeleccionado.fechasSelect : []"
        @input="getPartidos"
        placeholder="Fechas"
        :clearable="false"
        v-model="fechaSeleccionado"
        style="font-size:11px"
      />
    </div>
    <!-- DERECHA: Partidos -->
    <div class="panel-partidos">
      <div class="partidos-scroll">
        <div
          class="partido-card"
          v-for="partido in listPartidos"
          :key="partido.id_partido"
          @click="seleccionar(partido)"
          @contextmenu.prevent="deseleccionar(partido)"
        >
          <item-partido-asignacion
            :partido="partido"
            :activo="estaSeleccionado(partido)"
          ></item-partido-asignacion>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { ref } from '@vue/composition-api'
import //   BTabs,
//   BTab,
// BCard,
// BRow,
// BCol,
//   BButton,
//   VBTooltip,
//   xx,
//   xx,
//   xx,
//   xx,
//   xx,
'bootstrap-vue'
import vSelect from 'vue-select'
import apiCall from '../../utils/apiCall'
import {
  URL,
  //   USER,
  // ROLES,
  // DISCIPLINAS,
  // ACTION_INSERT
} from '../../utils/variables'
import ItemPartidoAsignacion from './ItemPartidoAsignacion.vue'

export default {
  components: {
    vSelect,
    // BCard,
    // BRow,
    // BCol,
    ItemPartidoAsignacion,
  },
  props: {
    item: Object,
    permitirSeleccionar: Boolean,
  },
  setup(props, { emit }) {
    const etapaSeleccionado = ref(null)
    const listPartidos = ref([])
    const fechaSeleccionado = ref({ label: 'fecha' })
    const { getApi } = apiCall()

    async function getPartidos(item) {
      // console.log(item)
      const path = `ApiFixture/getFixtureEtapaFecha/${etapaSeleccionado.value.id_campeonato}/${etapaSeleccionado.value.id_categoria}/${etapaSeleccionado.value.etapa}/${item.value}`
      const data = await getApi(URL, path)
      listPartidos.value = data
      // console.log(data)
    }
    const partidosSeleccionados = ref([])

    function seleccionar(partido) {
      const existe = partidosSeleccionados.value.find(
        p => p.id_partido === partido.id_partido,
      )

      if (!existe && props.permitirSeleccionar) {
        partidosSeleccionados.value.push(partido)
        emit('selecciono', partido)
      }
      // console.log(partidosSeleccionados.value)
    }

    function deseleccionar(partido) {
      partidosSeleccionados.value = partidosSeleccionados.value.filter(
        p => p.id_partido !== partido.id_partido,
      )
      emit('deselecciono', partido)
      // console.log(partidosSeleccionados.value)
    }

    function estaSeleccionado(partido) {
      return partidosSeleccionados.value.some(
        p => p.id_partido === partido.id_partido,
      )
    }
    return {
      etapaSeleccionado,
      fechaSeleccionado,
      getPartidos,
      listPartidos,
      seleccionar,
      deseleccionar,
      estaSeleccionado,
    }
  },
}
</script>
<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
.contenedor-principal {
  display: flex;
  width: 100%;
}

.panel-selects {
  width: 160px;
  flex-shrink: 0;
  padding: 10px;
  margin-bottom: 10px;
  background: aliceblue;
  border-radius: 10px;
}

.panel-partidos {
  width: calc(100% - 250px); /* 🔥 TOMA EL RESTO EXACTO */
  overflow: hidden;
  margin-left: 10px;
  margin-top: 28px;
}

.partidos-scroll {
  display: flex;
  overflow-x: auto;
  overflow-y: hidden;
  gap: 10px;
  scroll-behavior: smooth;
  white-space: nowrap;
}

.partido-card {
  flex: 0 0 auto;
}
// .partido-card {
//   flex: 0 0 auto;
//   cursor: pointer;
//   transition: all 0.2s ease;
//   border-radius: 6px;
// }

.nombre-equipo {
  font-weight: bolder;
}
</style>
